module["exports"] = [
  "#####",
  "### ##",
  "## ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/address/postcode.js
// module id = 1549
// module chunks = 0